export default {
  'menu.homePage': '主页',
  'menu.pufaxuanchuanPage': '普法宣传',
  'menu.messageListPage': '消息通知',
  'menu.minePage': '我的',
  'menu.UserSettingPage': '用户设置',

  // GENERATOR_KEEP_DO_NOT_DELETE_THIS_LINE
};
